// src/components/billing/SectionCard.jsx
import React from 'react';
import { Paper, Typography, Box, Divider, useTheme, alpha, Grow } from '@mui/material';

const SectionCard = ({ 
  title, 
  icon, 
  action, 
  children, 
  sx, 
  contentSx, 
  headerSx,
  elevation = 0, // Default to no shadow, but allow override
  interactive = false, // If true, add hover effect
  delay = 0, // For staggered animation if used in a list
  fullHeight = true, // By default, try to take full height of its grid cell
  ...props 
}) => {
  const theme = useTheme();

  return (
    <Grow in={true} timeout={300 + delay} style={{ transformOrigin: '0 0 0' }}>
      <Paper
        elevation={elevation}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: fullHeight ? '100%' : 'auto',
          borderRadius: '20px', // Slightly more rounded for a modern feel
          border: `1px solid ${theme.palette.divider}`,
          backgroundColor: theme.palette.background.paper,
          overflow: 'hidden',
          transition: theme.transitions.create(['box-shadow', 'border-color', 'transform'], {
            duration: theme.transitions.duration.short,
          }),
          ...(interactive && {
            '&:hover': {
              transform: 'translateY(-3px)',
              boxShadow: `0 8px 25px -5px ${alpha(theme.palette.primary.main, 0.1)}, 0 5px 15px -6px ${alpha(theme.palette.common.black, 0.08)}`,
              borderColor: alpha(theme.palette.primary.main, 0.5),
            },
          }),
          ...sx,
        }}
        {...props}
      >
        {(title || icon || action) && (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              p: theme.spacing(2.5, 3), // Increased padding slightly
              // Subtle gradient or slightly different bg for header can look good
              // background: `linear-gradient(to bottom, ${alpha(theme.palette.grey[50], 0.03)}, ${alpha(theme.palette.grey[50], 0)})`,
              borderBottom: (title || icon || action) && !(contentSx?.p === 0 || contentSx?.padding === 0 || contentSx?.py === 0 || contentSx?.paddingY === 0) 
                            ? `1px solid ${theme.palette.divider}` 
                            : 'none',
              ...headerSx,
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
              {icon && React.cloneElement(icon, { 
                sx: { 
                  color: theme.palette.primary.main, 
                  fontSize: '1.75rem', // Slightly larger icon
                  // background: alpha(theme.palette.primary.main, 0.1),
                  // borderRadius: '8px',
                  // p: 0.5,
                  // display:'flex', alignItems:'center', justifyContent:'center'
                }
              })}
              {title && <Typography variant="h6" component="div" fontWeight={600} sx={{color: theme.palette.text.primary}}>{title}</Typography>}
            </Box>
            {action && <Box>{action}</Box>}
          </Box>
        )}
        <Box 
          sx={{ 
            p: theme.spacing(3), // Consistent padding for content
            flexGrow: 1, 
            display: 'flex', // Useful for aligning content within
            flexDirection: 'column', // Default direction for content
            ...contentSx 
          }}
        >
          {children}
        </Box>
      </Paper>
    </Grow>
  );
};

export default SectionCard;